import React from 'react';
import PropTypes from 'prop-types';
import RadioIcon from '../RadioIcon';
import cx from '@/utils/cx';
import useStyle from './style';

const RadioButton = ({
  value,
  disabled,
  labelText,
  onChange,
  checked,
  className,
  orientation,
  icon,
  color,
  ...rest
}) => {
  const classes = useStyle({ orientation });

  return (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={cx(
        classes.radioButton,
        disabled && 'disabled',
        checked && 'checked',
        className,
      )}
      {...rest}
    >
      <input
        className="mainRadio"
        type="radio"
        name={value}
        value={value}
        checked={checked}
        aria-checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      {icon || <RadioIcon checked={checked} _color={color} />}
      {labelText && <span className="label">{labelText}</span>}
    </label>
  );
};

RadioButton.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  icon: PropTypes.node,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};

RadioButton.defaultProps = {
  className: '',
  disabled: false,
  checked: false,
  labelText: '',
  icon: undefined,
  color: 'primary',
  orientation: 'horizontal',
  onChange: () => {},
};

export default RadioButton;
